import styled from "styled-components";

const Default = styled.div`
    body {
        font-family: "Montserrat Alternates", sans-serif;
    }
`;

export default Default;
